<template>
    <v-flex v-if="menu" xs12 mb-4 pt-4 id="menu">
        <v-toolbar text>
            <v-toolbar-title>Меню</v-toolbar-title>
            <v-spacer/>
            <v-btn icon text>
                <v-switch v-model="menu.status"/>
            </v-btn>
        </v-toolbar>
        <v-layout flex wrap v-show="menu.status">
            <v-flex xs5>
                <v-subheader class="pa-0">Тайтл</v-subheader>
                <v-text-field
                    ref="menu_title"
                    v-model="menu.title"
                    text
                    solo
                    single-line/>
            </v-flex>
            <v-spacer/>
            <v-flex xs5>
                <v-subheader class="pa-0">Хэштег</v-subheader>
                <v-text-field
                    ref="menu_hashtag"
                    v-model="menu.hashtag"
                    text
                    solo
                    single-line/>
            </v-flex>
            <v-flex xs12>
                <v-subheader class="pa-0">Текст</v-subheader>
                <v-textarea
                    ref="menu_text"
                    v-model="menu.text"
                    text
                    solo
                    counter="255"/>
            </v-flex>
            <v-flex xs6>
                <v-layout flex wrap>
                    <v-flex xs5>
                        <upload-img :image-width="360" :image-height="475" :content-area="12" :title="`Главное меню`"
                                    v-model="image_menu">
                            <div slot="activator">
                                <v-avatar size="100%" v-ripple tile v-if="image_menu.imageURL">
                                    <img :src="image_menu.imageURL" alt=""/>
                                </v-avatar>
                                <v-avatar size="100%" v-ripple tile v-else-if="!image_menu.imageURL && image_menu.src">
                                    <img :src="rootURL + image_menu.src" alt=""/>
                                </v-avatar>
                                <v-avatar size="100%" v-ripple tile class="grey lighten-3" v-else>
                                    <img src="/static/img/media/text_block_blank.svg" alt=""/>
                                </v-avatar>
                            </div>
                        </upload-img>
                        <v-layout>
                            <v-flex xs12>
                                <v-subheader class="pa-0">PDF для главного меню</v-subheader>
                                <template v-if="menu.link_main_menu !== null">
                                    <v-btn color="error" class="v-btn--save" @click="menu.link_main_menu = null">
                                        Очистить
                                    </v-btn>
                                </template>
                                <template v-else>
                                    <v-text-field
                                        readonly
                                        label="Выберите pdf файл"
                                        @click="pdfSelect('main')"
                                        prepend-icon='attach_file'/>
                                    <input
                                        type="file"
                                        style="display: none"
                                        ref="pdfMain"
                                        accept="application/pdf"
                                        @change="event => pdfSelected(event, 'main')"/>
                                </template>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs5>
                        <upload-img :image-width="360" :image-height="475" :content-area="12" :title="`Второе меню`"
                                    v-model="image_bar">
                            <div slot="activator">
                                <v-avatar size="100%" v-ripple tile v-if="image_bar.imageURL">
                                    <img :src="image_bar.imageURL" alt=""/>
                                </v-avatar>
                                <v-avatar size="100%" v-ripple tile v-else-if="!image_bar.imageURL && image_bar.src">
                                    <img :src="rootURL + image_bar.src" alt=""/>
                                </v-avatar>
                                <v-avatar size="100%" v-ripple tile class="grey lighten-3" v-else>
                                    <img src="/static/img/media/text_block_blank.svg" alt=""/>
                                </v-avatar>
                            </div>
                        </upload-img>
                        <v-layout>
                            <v-flex xs12>
                                <v-subheader class="pa-0">PDF для второго меню</v-subheader>
                                <template v-if="menu.link_second_menu !== null">
                                    <v-btn color="error" class="v-btn--save" @click="menu.link_second_menu = null">
                                        Очистить
                                    </v-btn>
                                </template>
                                <template v-else>
                                    <v-text-field
                                        label="Выберите pdf файл"
                                        @click="pdfSelect('sec')"
                                        prepend-icon='attach_file'/>
                                    <input
                                        type="file"
                                        style="display: none"
                                        ref="pdfSec"
                                        accept="application/pdf"
                                        @change="event => pdfSelected(event, 'sec')"/>
                                </template>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-spacer/>
            <v-flex xs5>
                <v-layout flex wrap>
                    <v-flex xs12>
                        <v-subheader class="pa-0">Цвет кнопки</v-subheader>
                        <v-radio-group v-model="menu.btn_color" row class="mt-0">
                            <v-radio :color="`#${item.color}`" :value="`#${item.color}`" @click.native="changeBtnColor"
                                     v-for="(item, index) in colors" :key="index">
                                <div slot="label"><span :class="`circle circle--${item.color}`"></span></div>
                            </v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-flex xs12>
                        <v-subheader class="pa-0">Формат кнопки</v-subheader>
                        <v-radio-group v-model="menu.btn_border_radius" row class="mt-0">
                            <v-radio :color="btn_color" value="8" :checked="menu.btn_border_radius === 8">
                                <div slot="label">
									<span class="custom-btn custom-btn--border"
                                          :style="`background: ${menu.btn_color}; color: ${(menu.btn_color === '#FFFFFF') ? 'black' : 'white'}`">
										ОСНОВНОЕ МЕНЮ
									</span>
                                </div>
                            </v-radio>
                            <v-radio :color="btn_color" value="0" :checked="menu.btn_border_radius === 0">
                                <div slot="label">
									<span class="custom-btn"
                                          :style="`background: ${menu.btn_color}; color: ${(menu.btn_color === '#FFFFFF') ? 'black' : 'white'}`">
										ОСНОВНОЕ МЕНЮ
									</span>
                                </div>
                            </v-radio>
                        </v-radio-group>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12>
                <upload-img :image-width="1920" :image-height="450" :content-area="12" :title="`Фоновое изображение`"
                            v-model="image_bg">
                    <div slot="activator">
                        <v-avatar size="100%" v-ripple tile v-if="image_bg.imageURL">
                            <img :src="image_bg.imageURL" alt=""/>
                        </v-avatar>
                        <v-avatar size="100%" v-ripple tile v-else-if="!image_bg.imageURL && image_bg.src">
                            <img :src="rootURL + image_bg.src" alt=""/>
                        </v-avatar>
                        <v-avatar size="100%" v-ripple tile class="grey lighten-3" v-else>
                            <img src="/static/img/media/menu_bg_blank.svg" alt=""/>
                        </v-avatar>
                    </div>
                </upload-img>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import config from '../../config'
    import UploadImg from '../../components/Media/Upload'

    export default {
        name: 'siteMenu',
        components: { UploadImg },
        props: {
            menu: {
                type: Object,
                default: () => ({
                    title: '',
                    text: '',
                    hashtag: '',
                    img_main_menu: null,
                    img_bar_menu: null,
                    link_main_menu: null,
                    link_second_menu: null,
                    bg_img: null,
                    status: true,
                    btn_color: '',
                    btn_border_radius: 0
                })
            }
        },
        data: () => ({
            rootURL: '',
            image_menu: {
                src: '',
                imageURL: ''
            },
            image_bar: {
                src: '',
                imageURL: ''
            },
            image_bg: {
                src: '',
                imageURL: ''
            },
            colors: [
                { color: 'A1252E' },
                { color: 'D0021B' },
                { color: '00BD21' },
                { color: '000000' },
                { color: 'FFFFFF' },
            ],
            btn_color: '#000'
        }),
        mounted () {
            this.rootURL = config.rootPath
            this.image_menu.src = this.menu.img_main_menu
            this.image_bar.src = this.menu.img_bar_menu
            this.image_bg.src = this.menu.bg_img
        },
        methods: {
            changeBtnColor () {
                this.btn_color = this.menu.btn_color
            },
            pdfSelect (type) {
                type === 'main' ? this.$refs.pdfMain.click() : this.$refs.pdfSec.click()
            },
            pdfSelected (event, type) {
                const fileToLoad = event.target.files[0]
                const fileReader = new FileReader()
                const size = fileToLoad.size / 1024 / 1024

                if (size > 5) {
                    this.$store.commit('showSnackbar', { text: 'Размер pdf не должен превышать 5Mb' })

                    return false
                }

                fileReader.readAsDataURL(fileToLoad)
                fileReader.onload = () => {
                    if (type === 'main') {
                        this.menu.link_main_menu = fileReader.result
                    } else {
                        this.menu.link_second_menu = fileReader.result
                    }
                }
            }
        },
        watch: {
            image_menu: function (newValue) {
                this.menu.img_main_menu = newValue
            },
            image_bar: function (newValue) {
                this.menu.img_bar_menu = newValue
            },
            image_bg: function (newValue) {
                this.menu.bg_img = newValue
            }
        }
    }
</script>

<style lang="scss" scoped>.circle {
    width: 40px;
    height: 40px;
    display: block;
    border-radius: 50%;

    &--A1252E {
        background-color: #A1252E;
    }

    &--D0021B {
        background-color: #D0021B;
    }

    &--00BD21 {
        background-color: #00BD21;
    }

    &--000000 {
        background-color: #000;
    }

    &--FFFFFF {
        background-color: #fff;
    }
}

.custom-btn {
    height: 45px;
    width: 130px;
    display: block;
    text-align: center;
    font: 500 13px / 45px 'Roboto';
    background-color: rgba(#000, 0.5);

    &--border {
        border-radius: 8px;
    }
}
</style>
